// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-section-inventory-incominglinks',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fa-fw mr-2 text-link mt-1 fas fa-sign-in-alt" aria-hidden="true"></span>
            <div>
                <h2 class="font-weight-300 mb-0" translate>
                    Incoming links
                </h2>
                <span class="text-grey" translate [translate-args]="{count: links.total}">
                    [[count]] found
                </span>
            </div>
        </div>
        <mon-tabs [showSearch]="true"
                  [options]="tabOptions"
                  [(status)]="activeTab"
                  (onStatus)="onStatus($event)"
                  (onSearch)="onSearch($event)"
                  [search]="search"
                  [minSearchLength]="1"
                  [showFiltersBtn]="false">
            <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                        [noResultMessage]="'Zero links were found' | translate"
                        [collection]="links"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="promise">
                    <table class="table table-hover table-fixed table-vertial-align">
                        <thead>
                        <tr>
                            <th class="col-20">
                                <span class="inline-block ml-3" translate>
                                    Link
                                </span>
                            </th>
                            <th class="col-20">
                                <span class="mr-3" translate>Original Data</span>
                            </th>
                            <th class="col-6 text-right">
                                <span class="mr-3" translate>Link Type</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let link of links">
                                <td class="text-ellipsis">
                                    <mon-url-title
                                            *ngIf="!pageDetailsIsAvailable"
                                            [title]="link.title"
                                            [url]="link.url"
                                            [active]="false">
                                    </mon-url-title>
                                    <url-title-page-details
                                            *ngIf="pageDetailsIsAvailable"
                                            class="inline-block pl-3 pr-0 text-ellipsis"
                                            [title]="link.title"
                                            [url]="link.url"
                                            [page]="pageObj"
                                            [active]="false">
                                    </url-title-page-details>
                                </td>
                                <td class="text-ellipsis">
                                    <div class="row">
                                        <div class="col-sm-8 col-md-6 col-lg-5 text-bold" translate>URL:</div>
                                        <div class="col-sm-40 col-md-42 col-lg-43 pl-0 text-ellipsis tooltip_url text-nowrap">
                                            <a [href]="link.url" target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'" [title]="link.orig_url">
                                                {{link.orig_url}}
                                            </a>
                                        </div>

                                        <div class="col-sm-8 col-md-6 col-lg-5 text-bold" translate>Text:</div>
                                        <div class="col-sm-8 col-md-6 col-lg-43 pl-0 text-ellipsis tooltip_url text-nowrap"
                                             [ngbTooltip]="link.text"
                                             [triggers]="'focus hover'">
                                            {{link.text}}
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <span class="label label-default mr-3">{{ link.type | capitalize}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PageDetailsSectionInventoryIncominglinksComponent extends BaseContainerComponentController implements OnInit {
    @Input() pageObj: any;

    pageDetailsIsAvailable: boolean = false;
    links: any = [];
    tabOptions: any[] = [];
    exports: any[] = [];
    promise: any;

    constructor (
        private pageRepoService: PageRepoService,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true });
        this.getPage = this.loadPage.bind(this);
    }

    ngOnInit (): void {
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pageObj = this.pageObj || {};
        this.links = [];
        this.activeTab = '0';
        this.search = '';
        this.setupTabs();
        this.loadPage();
        this.setExports(this.pageObj.id);
    }

    setupTabs (): void {
        this.tabOptions = [
            {
                name: this.translateService.getString('Links from own domain'),
                value: '0',
            },
            {
                name: this.translateService.getString('Links from other account domains'),
                value: '1',
            },
        ];
    }

    loadPage (): void {
        const params: any = {
            page_size: this.pageSize,
            page: this.page,
            all: this.activeTab,
            search: this.search,
        };

        this.promise = this.pageRepoService.getIncomingLinks(this.pageObj.id, params).then((data: any) => {
            this.links = data;
            this.setupTabs();
            this.tabOptions[this.activeTab].name += ' (' + this.links.total + ')';
        });
    }

    setExports (pageId: any): void {
        this.exports = [
            {
                name: this.translateService.getString('Incoming Links'),
                data: {
                    category: 'incoming_links',
                    category_ref: pageId,
                },
            },
        ];
    }

    trackByIndex (index: number): number {
        return index;
    }
}
